export var certificateDIP = 'CertificateDIP';
export var decisionInPrinciple = 'Decision in Principle';
export var formTypeStatusName = {
    referred: 'Referred',
    declined: 'Declined',
    approved: 'Approved',
};
export var referredText = 'You will be notified of their decision by email.';
export var otherText = {
    download: 'Download',
    form: 'Form',
    certificate: 'Certificate',
    submit: 'Submit',
};
export var activeApplicationForm = {
    heading: 'Confirm your submission?',
    text: "You are about to submit this stage of the process.Please take a moment to review the details you have entered before progressing.",
};
export var buttonText = {
    submit: 'Submit',
    fees: 'Fees',
    declarations: 'Declarations',
};
export var completionStatus = {
    pending: 'pending',
    error: 'error',
    success: 'success',
};
